import { Spinner } from "../../../../atoms";

const ListExceptionApiLoading = () => {
  return (
    <Spinner></Spinner>
  );
};

export default ListExceptionApiLoading;
